/**
 * Set button to a loading or finished state
 *
 * @since 1.0.0
 */

export function setInitial(el) {
  el.classList.remove('c-button--loading')
  el.classList.remove('c-button--finished')
}

export function setLoading(el) {
  el.classList.add('c-button--loading')
}

export function setFinished(el) {
  el.classList.remove('c-button--loading')
  el.classList.add('c-button--finished')
}

export function LoadingButton() {
  const buttons = document.querySelectorAll('.js-loading-button')
  if (buttons.length < 1) return
  
  ;[...buttons].forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault()
      setLoading(button)
      setTimeout(() => {
        setFinished(button)
        setTimeout(() => {
          setInitial(button)
        }, 2000)
      }, 2000)
    })
  })
}


// WEBPACK FOOTER //
// ./src/js/modules/LoadingButton.js